// src/hooks/useLibraryData.js
import { useEffect } from "react";
import { useAppData } from "../contexts/AppDataContext";
import { queryCache } from "../lib/queryCache";

/**
 * useLibraryData hook
 * Backed by global AppDataContext cache so Dashboard, Library, and FolderView
 * share the exact same in-memory state with zero redundant network requests.
 */
export const useLibraryData = () => {
  const {
    folders,
    setFolders,
    recentNotes,
    setRecentNotes,
    libraryLoading,
    refreshLibrary,
    addFolderToState,
    markNoteAccessed,
  } = useAppData();

  useEffect(() => {
    // If cache was invalidated (e.g. after study session or reading progress save),
    // silently re-sync library data in background
    if (!queryCache.get("library_recent_notes") || !queryCache.get("library_folders")) {
      refreshLibrary();
    }
  }, [refreshLibrary]);

  return {
    folders,
    setFolders,
    recentNotes,
    setRecentNotes,
    loading: libraryLoading,
    refresh: refreshLibrary,
    addFolderToState,
    markNoteAccessed,
  };
};

export default useLibraryData;
